module.exports = __webpack_public_path__ + "static/nft-defi-63d26baddd0abf3fd681ef6b7f8cc830.png";